import type { IconSvgObject } from './types';

const Medal03Icon: IconSvgObject = [
  ["path", { d: "M16.0001 14L12.0001 12L8 14V19L12.0001 21L16.0001 19V14Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 3L12 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M20.5 3H3.5V8L12 12L20.5 8V3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Medal03Icon;
